<template>
  <div class="delay-input-wrapper">
    <label v-if="label">{{ label }}</label>
    <div class="delay-input-group">
      <input
        v-model.number="displayValue"
        type="number"
        :placeholder="placeholder"
        min="0"
      />
      <select v-model="delayUnit" class="delay-unit-select">
        <option value="minutes">{{ unitLabels.minutes }}</option>
        <option value="hours">{{ unitLabels.hours }}</option>
        <option value="days">{{ unitLabels.days }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DelayInput',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '2',
    },
    unitLabels: {
      type: Object,
      default: () => ({
        minutes: 'Minutos',
        hours: 'Horas',
        days: 'Dias',
      }),
    },
  },
  data() {
    return {
      displayValue: 0,
      delayUnit: 'minutes',
    };
  },
  computed: {
    delayInMinutes() {
      return this.convertToMinutes(this.displayValue);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.initializeFromMinutes(newVal || 0);
      },
    },
    delayInMinutes(newVal) {
      this.$emit('input', newVal);
    },
  },
  methods: {
    initializeFromMinutes(minutes) {
      // Verifica se é exatamente dias (1440 minutos = 1 dia)
      if (minutes > 0 && minutes % 1440 === 0) {
        this.displayValue = minutes / 1440;
        this.delayUnit = 'days';
      }
      // Verifica se é exatamente horas (60 minutos = 1 hora)
      else if (minutes > 0 && minutes % 60 === 0) {
        this.displayValue = minutes / 60;
        this.delayUnit = 'hours';
      }
      // Caso contrário, mantém em minutos
      else {
        this.displayValue = minutes;
        this.delayUnit = 'minutes';
      }
    },
    convertToMinutes(value) {
      const numValue = Number(value) || 0;
      switch (this.delayUnit) {
        case 'hours':
          return numValue * 60;
        case 'days':
          return numValue * 1440;
        default:
          return numValue;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.delay-input-wrapper {
  label {
    display: block;
    margin-bottom: 0.5rem;
  }
}

.delay-input-group {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  width: 100%;
}

.delay-input-group input {
  flex: 1;
  min-width: 6rem;
}

.delay-unit-select {
  width: auto;
  min-width: 6rem;
}
</style>
